import ActionBtn from "components/buttons/ActionBtn";
import FilterTabs from "components/FilterTabs";
import SearchDropdown, {
  Item,
} from "components/dropdowns/SearchDropdown/SearchDropdown";
import React from "react";
import { useTranslation } from "react-i18next";
import { CountryType } from "store/countries/slice";
import styles from "./CountriesHeader.module.scss";
import { RefreshButton } from "components/buttons/RefreshButton";

type Props = {
  selectedType: CountryType;
  types: CountryType[];
  onSelectType: (type: CountryType) => void;
  createModal?: () => void;
  selectedDomain: string;
  domains: string[];
  isDomainsFetching: boolean;
  onSelectDomain: (domain: string) => void;
  isCreateAllowed?: boolean;
  refresh?: () => void;
  isRefreshRequested?: boolean;
};

export const CountriesHeader: React.FC<Props> = ({
  selectedType,
  types,
  onSelectType,
  createModal = () => {},
  selectedDomain,
  domains,
  isDomainsFetching,
  onSelectDomain,
  isCreateAllowed,
  refresh = () => {},
  isRefreshRequested
}) => {
  const { t } = useTranslation();
  const selectedDomainItem: Item[] = selectedDomain
    ? [{ value: selectedDomain, label: selectedDomain }]
    : [];

  return (
    <div className="page-list-header">
      <div className="page-list-header--box">
        {isCreateAllowed && (
          <ActionBtn txt={t("addNotification")} handleClick={createModal} />
        )}
        <div className={styles.domainSelect}>
          <SearchDropdown
            mode="single"
            isClearable={false}
            keepSelectedInList
            label={t("selectDomain")}
            items={domains.map((domain) => ({ value: domain, label: domain }))}
            defaultValues={selectedDomainItem}
            onSelect={(item) =>
              onSelectDomain(item.removed ? "" : String(item.value))
            }
            disabled={isDomainsFetching}
          />
        </div>
      </div>
      <div className="page-list-header--box page-list-header--box--right">
        <RefreshButton
          position="right"
          disabled={isRefreshRequested}
          isLoading={isRefreshRequested}
          onClick={() => refresh()}
        />
      </div>
      <div className="page-list-header--box">
        <FilterTabs
          value={selectedType}
          onSelect={(type) => onSelectType(type as CountryType)}
          options={types.map((type) => ({ label: t(type), value: type }))}
        />
      </div>
    </div>
  );
};
